import { notifications } from "@mantine/notifications"
import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { CreateProductionSiteFieldDefinition } from "@tfg/types/schemas/modules/traceability/queries/create-production-site-field-definition.dto"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

export const useCreateProductionSiteFieldDefinitionMutation = (
  orgId: number,
  options?: UseMutationOptions<
    unknown,
    AxiosError,
    CreateProductionSiteFieldDefinition
  >
) =>
  useMutation({
    mutationFn: async (
      prodSiteFieldDef: CreateProductionSiteFieldDefinition
    ) => {
      return await httpClient.post(
        `/admin/traceability/create-production-site-field-definition`,
        prodSiteFieldDef
      )
    },
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)

      notifications.show({
        title: "Success",
        message: "Production field definition created",
        color: "green",
      })

      queryClient.invalidateQueries(["prodSiteFieldDefs", orgId])
    },
    onError: (error: AxiosError) => {
      notifications.show({
        title: "Error",
        message: error.message,
        color: "red",
      })
    },
  })
